import e, { createContext as t, Component as r, Children as n, cloneElement as i } from "react";
import { getFlippedElementPositionsBeforeUpdate as o, onFlipKeyUpdate as p, utilities as l, constants as a, spring as s } from "flip-toolkit";
function c(e, t) {
  if (null == e) return {};
  var r,
    n,
    i = {},
    o = Object.keys(e);
  for (n = 0; n < o.length; n++) t.indexOf(r = o[n]) >= 0 || (i[r] = e[r]);
  return i;
}
var d = t({}),
  f = t("portal"),
  u = function (t) {
    var r, n;
    function i() {
      var e;
      return (e = t.apply(this, arguments) || this).inProgressAnimations = {}, e.flipCallbacks = {}, e.el = void 0, e;
    }
    n = t, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n;
    var l = i.prototype;
    return l.getSnapshotBeforeUpdate = function (e) {
      return e.flipKey !== this.props.flipKey && this.el ? o({
        element: this.el,
        flipCallbacks: this.flipCallbacks,
        inProgressAnimations: this.inProgressAnimations,
        portalKey: this.props.portalKey
      }) : null;
    }, l.componentDidUpdate = function (e, t, r) {
      this.props.flipKey !== e.flipKey && this.el && p({
        flippedElementPositionsBeforeUpdate: r.flippedElementPositions,
        cachedOrderedFlipIds: r.cachedOrderedFlipIds,
        containerEl: this.el,
        inProgressAnimations: this.inProgressAnimations,
        flipCallbacks: this.flipCallbacks,
        applyTransformOrigin: this.props.applyTransformOrigin,
        spring: this.props.spring,
        debug: this.props.debug,
        portalKey: this.props.portalKey,
        staggerConfig: this.props.staggerConfig,
        handleEnterUpdateDelete: this.props.handleEnterUpdateDelete,
        decisionData: {
          previous: e.decisionData,
          current: this.props.decisionData
        },
        onComplete: this.props.onComplete,
        onStart: this.props.onStart
      });
    }, l.render = function () {
      var t = this,
        r = this.props,
        n = r.portalKey,
        i = e.createElement(d.Provider, {
          value: this.flipCallbacks
        }, e.createElement(r.element, {
          className: r.className,
          ref: function ref(e) {
            return t.el = e;
          }
        }, this.props.children));
      return n && (i = e.createElement(f.Provider, {
        value: n
      }, i)), i;
    }, i;
  }(r);
u.defaultProps = {
  applyTransformOrigin: !0,
  element: "div"
};
var h = function h(e) {
    var t,
      r = e.children,
      o = e.flipId,
      p = e.inverseFlipId,
      s = e.portalKey,
      d = c(e, ["children", "flipId", "inverseFlipId", "portalKey"]),
      f = r,
      u = function (e) {
        return "function" == typeof e;
      }(f);
    if (!u) try {
      f = n.only(r);
    } catch (e) {
      throw new Error("Each Flipped component must wrap a single child");
    }
    d.scale || d.translate || d.opacity || l.assign(d, {
      translate: !0,
      scale: !0,
      opacity: !0
    });
    var h = ((t = {})[a.DATA_FLIP_CONFIG] = JSON.stringify(d), t);
    return void 0 !== o ? h[a.DATA_FLIP_ID] = String(o) : p && (h[a.DATA_INVERSE_FLIP_ID] = String(p)), void 0 !== s && (h[a.DATA_PORTAL_KEY] = s), u ? f(h) : i(f, h);
  },
  m = function m(t) {
    var r = t.children,
      n = t.flipId,
      i = t.shouldFlip,
      o = t.shouldInvert,
      p = t.onAppear,
      a = t.onStart,
      s = t.onStartImmediate,
      u = t.onComplete,
      m = t.onExit,
      g = t.onSpringUpdate,
      y = c(t, ["children", "flipId", "shouldFlip", "shouldInvert", "onAppear", "onStart", "onStartImmediate", "onComplete", "onExit", "onSpringUpdate"]);
    return r ? y.inverseFlipId ? e.createElement(h, Object.assign({}, y), r) : e.createElement(f.Consumer, null, function (t) {
      return e.createElement(d.Consumer, null, function (c) {
        return l.isObject(c) && n && (c[n] = {
          shouldFlip: i,
          shouldInvert: o,
          onAppear: p,
          onStart: a,
          onStartImmediate: s,
          onComplete: u,
          onExit: m,
          onSpringUpdate: g
        }), e.createElement(h, Object.assign({
          flipId: n
        }, y, {
          portalKey: t
        }), r);
      });
    }) : null;
  };
m.displayName = "Flipped";
var g = function g(e) {
  var t;
  return i(e.children, ((t = {})[a.DATA_EXIT_CONTAINER] = !0, t));
};
export { g as ExitContainer, m as Flipped, u as Flipper, s as spring };